export default __webpack_public_path__ + "mobile-phone.png";